import { setImpersonatingFlag } from '@common/auth/utils';
import { Private_Routes } from '@common/url';
import { NestedData } from '@prophecy/interfaces/generic';
import { Centered, Stack } from '@prophecy/ui-v3';
import { message, Alert } from '@prophecy/ui-v3/ui-compat';
import { navigateAndRefresh } from '@prophecy/utils/history';
import { usePersistentCallback } from '@prophecy/utils/react/hooks';
import { useMutation as useReactMutation } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { authenticateUsingToken } from '../../../../data/apis/api';

type TokenResp = {
  message: string;
  success: boolean;
};

export default function LoginUsingToken() {
  const authMutation = useReactMutation<TokenResp, TokenResp, { token: string }>(
    ['GenerateToken'],
    (data: NestedData) => {
      return authenticateUsingToken(data);
    },
    { retry: false }
  );
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const authenticateUser = usePersistentCallback(async (token: string) => {
    await authMutation.mutateAsync(
      { token },
      {
        onSuccess: (resp) => {
          if (resp.success) {
            setImpersonatingFlag(true);
            navigateAndRefresh(Private_Routes.Home.getUrl());
          }
        },
        onError: (error) => {
          message.error({ content: error?.message || 'Authentication failed.' });
        }
      }
    );
  });

  useEffect(() => {
    if (token) {
      authenticateUser(token);
    }
  }, [token, authenticateUser]);
  const mutationData = authMutation?.data;

  return (
    <Stack width='100%' height='100%' align='center' alignY='center'>
      <Centered>
        {/*CSS used from index.html for below class names*/}
        {authMutation.isError || !mutationData?.success ? (
          <Alert variant='error'>{mutationData?.message || 'Authetication failed.'}</Alert>
        ) : (
          <div className='prophecy-html-logo'>
            <div className='rect1'></div>
            <div className='rect2'></div>
            <div className='rect3'></div>
            <div className='rect4'></div>
          </div>
        )}
      </Centered>
    </Stack>
  );
}
